import React, { useRef, useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import Tabs from 'srcReact/components/common2/Tabs'
import styles from './styles.module.scss'
import MediaTabContent from 'srcReact/components/common2/MediaTabContent'
import { mixrActions } from 'srcReact/Mixr/actions'
import Spinner from 'srcReact/components/common2/Spinner'

export default function Medias({ mixrId, isStatic }) {
  const { t } = useTranslation()
  const [scope, setScope] = useState('pictures_media')
  const fileInputRef = useRef(null)
  const dispatch = useDispatch()
  const {
    common: { isNative },
    mixr: { mixr, pictures, documents, deleteFileLoading, loadingMedias }
  } = useSelector((state) => state)

  const openFileDialog = () => {
    fileInputRef.current.click()
  }

  const showPhotos = () => {
    setScope('pictures_media')
  }
  const showLinks = () => {
    setScope('links_media')
  }
  const showDocuments = () => {
    setScope('documents_media')
  }
  const handleDelete = (fileId) => {
    dispatch(mixrActions.deleteFileFromMixr(mixrId, fileId))
  }

  return (
    <div className={styles.mediaWrapper} id='mediaWrapper'>
      {loadingMedias ? (
        <Spinner />
      ) : (
        <Tabs type='boxed'>
          <div onClick={showPhotos} label={t('mixrHome.media.photos')}>
            <MediaTabContent
              id={mixrId}
              type='mixr'
              scope={scope}
              title={t('mixrHome.media.mixrPhotos')}
              noDatatitle={t('mixrHome.media.noPhotos')}
              files={pictures}
              handleDelete={handleDelete}
              deleteFileLoading={deleteFileLoading}
              isStatic={isStatic}
            />
          </div>
          <div onClick={showLinks} label={t('mixrHome.media.links')}>
            <MediaTabContent
              id={mixrId}
              type='mixr'
              scope={scope}
              title={t('mixrHome.media.mixrLinks')}
              noDatatitle={t('mixrHome.media.noLinks')}
              handleDelete={handleDelete}
              deleteFileLoading={deleteFileLoading}
              isStatic={isStatic}
            />
          </div>
          <div onClick={showDocuments} label={t('mixrHome.media.documents')}>
            <MediaTabContent
              id={mixrId}
              type='mixr'
              scope={scope}
              title={t('mixrHome.media.mixrDocs')}
              noDatatitle={t('mixrHome.media.noDocuments')}
              files={documents}
              handleDelete={handleDelete}
              deleteFileLoading={deleteFileLoading}
              isStatic={isStatic}
            />
          </div>
        </Tabs>
      )}
    </div>
  )
}
